module.exports = __webpack_public_path__ + "assets/9e675ec8eee3afd45cb9a1686032cedd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/Multiple_Stem_XXX.mp3
 ** module id = 500
 ** module chunks = 0
 **/